import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "../utils/axiosConfig";
import { formatReportDate } from "../utils/reportDate";

const DashboardReminders = () => {
  const [reminders, setReminders] = useState([]);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    axios.get("/newdeal/reminders/due").then(res => {
      if (!active) return;
      const rows = Array.isArray(res.data) ? res.data : [];
      setReminders(rows);
      setOpen(rows.length > 0);
    }).catch(() => { if (active) setError("Unable to load reminders. Please refresh the dashboard."); });
    return () => { active = false; };
  }, []);
  const complete = async id => {
    setBusy(id);
    setError("");
    try {
      await axios.patch(`/newdeal/reminders/${id}/complete`);
      setReminders(current => current.filter(row => row.ReminderID !== id));
    } catch (err) { setError(err.response?.data?.message || "Unable to complete reminder"); }
    finally { setBusy(null); }
  };
  return <>
    {error && <div className="dashboard-error" role="alert">{error}</div>}
    {reminders.length > 0 && <div className="dashboard-panel my-3">
      <h2>Due Reminders ({reminders.length})</h2>
      <button type="button" className="btn btn-warning" onClick={() => setOpen(true)}>View Reminders</button>
    </div>}
    {open && reminders.length > 0 && <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable"><div className="modal-content" role="dialog" aria-modal="true" aria-labelledby="due-reminders-title">
        <div className="modal-header"><h5 id="due-reminders-title">Due Reminders</h5>
          <button type="button" className="btn-close" aria-label="Close reminders" onClick={() => setOpen(false)} /></div>
        <div className="modal-body">
          {error && <div role="alert" className="text-danger">{error}</div>}
          {reminders.map(row => <div key={row.ReminderID} className="border rounded p-3 mb-3">
            <div className="d-flex justify-content-between gap-2 flex-wrap">
              <Link to={`/transaction/new-deal/edit/${row.DealID}`}>{row.DealNo || `Deal ${row.DealID}`}</Link>
              <span>Due: {formatReportDate(row.ReminderDate)}</span>
            </div>
            <p className="my-2" style={{ whiteSpace: "pre-wrap" }}>{row.Message}</p>
            {row.CreatedByName && <div className="text-muted mb-2">Created by {row.CreatedByName}</div>}
            <button type="button" className="btn btn-success btn-sm" disabled={busy !== null} onClick={() => complete(row.ReminderID)}>
              {busy === row.ReminderID ? "Saving…" : "Mark Done"}
            </button>
          </div>)}
        </div>
        <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={() => setOpen(false)}>Close</button></div>
      </div></div>
    </div>}
  </>;
};
export default DashboardReminders;
